var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.5L4 9.5L5 9.5L5 8.5L6 8.5L6 7.5L7 7.5L7 6.5L8 6.5L8 5.5L7 5.5L7 4.5L6 4.5L6 3.5L5 3.5L5 2.5L4 2.5L4 3.5L5 3.5L5 4.5L6 4.5L6 5.5L7 5.5L7 6.5L6 6.5L6 7.5L5 7.5L5 8.5L4 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightS);
export default __webpack_public_path__ + "static/media/arrow-right-s.28017cd4554ec828080e8902a1b38fd1.svg";
export { ForwardRef as ReactComponent };